module.exports = __webpack_public_path__ + "static/media/notification-user-management.85edd9c3.svg";